/** Categories evaluated first so FieldShingles qty is in scope for dependent formulas */
export const FORMULA_EVAL_ORDER: string[] = [
    "Field Shingles",
    "Starter",
    "Double Starter",
    "Hip & Ridge",
    "Ice & Water Shield",
    "Field Dry In Synthetic",
    "Field Dry In 15 Felt",
    "Valley Liner",
    "Drip Edge / Eave",
    "Drip Edge / Rake",
    "Head Wall Metal",
    "Step Flashing",
    "Roll Valley",
    "Counter Flashing",
    "Valley metal",
    "Box Roof Vent",
    "Turbine Roof Vent",
    "Ridge Vent",
    "Plumbing Jacks",
    "Splitboot",
    "Furnace Jacks",
    "Furnace Cap",
    "Furnace Collar",
    "Bath Vent",
    "Dryer Vent",
    "Roof Nails",
    "H&R Nails",
    "Nails - Plastic cap nails",
    "Sealant / Adhesive",
    "Spray Paint",
    "Gutters",
    "Downspouts",
    "Gutter Screens",
];
